import DateTimeInput from './Input'
export const DateTimePicker = (props) => {
    return <DateTimeInput {...props} />
}